import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { Funnel, ProductResponse, ResponseDetails } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';


export type DTO1 = {
    page: number;
    perPage: number;
    search?: string;
    filter?: any;
    isArchived?: boolean
};

export const getFunnelList = (
    {  page, perPage, search, filter , isArchived}: DTO1 = {
      page: 1,
      perPage: 20,
    }
  ): Promise<ProductResponse> => {
    return axios.post(`/superAdmin/get-funnel-list`,  {
      page,
      perPage,
      search,
      filter,
      isArchived
     });
  };


type UseOptions = {
  config?: MutationConfig<typeof getFunnelList>;
};

export const useGetFunnelList= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getFunnelList,
  });
};




export type DTO11 = {
  id: number;
}

export const getFunnelDetail = (
  {  id }: DTO11 
): Promise<ResponseDetails> => {
  return axios.post(`/superAdmin/get-funnel-details/${id}`);
};


type UseOptionss = {
config?: MutationConfig<typeof getFunnelDetail>;
};

export const useGetFunnelDetails= ({ config }: UseOptionss = {}) => {
return useMutation({
  ...config,
  mutationFn: getFunnelDetail,
});
};

